import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

const sendReferralToUser = (referralId: number, receiverId: number) => {
  return postRequest('/referral-shares/send', { referralId, receiverId })
}

export const useSendReferralToUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ referralId, receiverId }: { referralId: number; receiverId: number }) =>
      sendReferralToUser(referralId, receiverId),
    onSuccess: (_, { referralId }) => {
      queryClient.invalidateQueries({ queryKey: queries.referralShares.list._def })
      queryClient.invalidateQueries({ queryKey: queries.referrals.list._def })
      queryClient.invalidateQueries({ queryKey: queries.referrals.detail(referralId).queryKey })
    },
  })
}
